
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/user-preferences",
      function () {
        return require("private-next-pages/register/user-preferences.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register/user-preferences"])
      });
    }
  